import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

import "../ExploreTourism/ExploreTourism.css";
import Heading from "../../../utls/Heading";
const destinations = [
  { name: "India", image: 'https://blueberrydatastorage.blob.core.windows.net/bbt/icons/TourismIcons/INDIA-ICON.png' },
  { name: "Dubai", image: 'https://blueberrydatastorage.blob.core.windows.net/bbt/icons/TourismIcons/DUBAI-ICON.png' },
  { name: "China", image: 'https://blueberrydatastorage.blob.core.windows.net/bbt/icons/TourismIcons/CHINA-ICON.png' },
  { name: "Egypt", image: 'https://blueberrydatastorage.blob.core.windows.net/bbt/icons/TourismIcons/EGYPT-ICON.png' },
  { name: "Thailand", image: 'https://blueberrydatastorage.blob.core.windows.net/bbt/icons/TourismIcons/THAILAND-ICON.png' },
  { name: "USA", image: 'https://blueberrydatastorage.blob.core.windows.net/bbt/icons/TourismIcons/USA-ICON.png' },
  { name: "Japan", image: 'https://blueberrydatastorage.blob.core.windows.net/bbt/icons/TourismIcons/JAPAN-ICON.png' },
  { name: "Jordan", image: 'https://blueberrydatastorage.blob.core.windows.net/bbt/icons/TourismIcons/Jordan-ICON.png' },
  { name: "South Korea", image: 'https://blueberrydatastorage.blob.core.windows.net/bbt/icons/TourismIcons/SouthKorea-Icon.png' },
  { name: "Maldives", image: 'https://blueberrydatastorage.blob.core.windows.net/bbt/icons/TourismIcons/Maldives-icon.png' },
];

const ExploreTourism = () => {
  return (
    <div className="ExploreTourism-main-div">
      <div className="container">
    
        <Heading className="customheadings text-center mt-3 mb-3"> 
                <span>Explore Our </span>Top Travel Destinations
              </Heading>
        {/* First Row - First 5 Images */}
        <div className="row justify-content-center">
          {destinations.slice(0, 5).map((destination, index) => (
            <div key={index} className="col-md-2 Explore-tourism-destination-div d-flex me-3 my-2">
              <LazyLoadImage
            effect="blur"
 src={destination.image} alt={destination.name} className="destination-img"/>
              <div>
                <span className="destination-name">{destination.name}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Second Row - Next 5 Images */}
        <div className="row justify-content-center">
          {destinations.slice(5, 10).map((destination, index) => (
            <div key={index} className="col-md-2 Explore-tourism-destination-div d-flex me-3 my-2">
              <LazyLoadImage
            effect="blur"
 src={destination.image} alt={destination.name} className="destination-img"/>
              <div>
                <span className="destination-name">{destination.name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExploreTourism;
